var template = require('../templates/Reports.html');

module.exports = Backbone.View.extend({

    initialize: function() {
        this.render();
    },

    render: function() {
        var self = this;
        self.$el.html(template());
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/Reports.js